const commentsData = [
  {
    name: '星月夜',
    avatar: 'profile-01',
    date: '2026-07-25',
    content: '无意间发现酷看漫画，分类真的太全了！之前找韩漫总是要翻好几个站，现在这里韩漫、日漫、国漫一网打尽，推荐算法也很准，推给我的几部玄幻漫画都超好看。',
    tag: '韩漫爱好者',
  },
  {
    name: '风间琉璃',
    avatar: 'profile-02',
    date: '2026-07-22',
    content: '从高中开始追日漫，现在快十年了。酷看的日漫分类做得很细致，按类型、年代、作者都能找到。最近通过排行榜发现的几部恋爱漫画，画风和剧情都很在线！',
    tag: '日漫老粉',
  },
  {
    name: '墨染青衣',
    avatar: 'profile-03',
    date: '2026-07-20',
    content: '国漫这几年真的越来越好了！狐妖、全职这些都是追了好几年的作品。酷看漫画把国漫单独分类整理，还按热度排名，找新番特别方便。希望国漫专区越做越好！',
    tag: '国漫铁粉',
  },
  {
    name: '七月的风',
    avatar: 'profile-04',
    date: '2026-07-18',
    content: '每天通勤路上用酷看漫画 App 追更，离线下载功能太好用了！在地铁里信号不好也能看。更新推送也很及时，喜欢的漫画一更新马上就能收到通知，追更神器！',
    tag: 'App用户',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">读者怎么说</h2>
          <p className="text-sm text-foreground-500">来自真实漫画爱好者的使用反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-3-line text-primary-500 text-base"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-bold text-foreground-900">{comment.name}</h3>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
                <div className="flex items-center gap-0.5 text-accent-500">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}